import { useTranslation } from 'react-i18next'
import { propEq, find, path, pipe, allPass } from 'ramda'
import {
  LabeledValue,
  DocumentView,
  CollapsibleContainer,
  LabelText,
  DocumentStatusComponent
} from '@/features/Application/elements'
import getLabels from '@/features/Profile/EmploymentInfo/labels'
import useFinancialFiles from '@/hooks/use-financial-files'
import useRole from '@/hooks/use-role'

const Mobile = ({
  data = {},
  isLocked,
  application,
  isEmploymentDoc = false,
  isLoading,
  tag = '',
  standalone = false
}) => {
  const { t } = useTranslation()
  const userRole = useRole()

  const userId = application?.user_id
  const userFiles = userId ? application?.users?.[userId]?.files?.user_secure_files : undefined
  const secureFiles = useFinancialFiles(userFiles, userRole)

  const LABELS = getLabels(t)

  const document = pipe(find(allPass([propEq('document_type', data?.type), propEq('tag', tag)])))(
    secureFiles
  )
  const docType = document?.tag?.split('_')?.[0]
  const documentType = isEmploymentDoc && docType === 'school' ? 'employment' : docType
  const documentStatus = path(
    ['trust_score', 'trustworthiness', documentType, 'details', 0, 'status'],
    application
  )
  const disabled = documentStatus !== 'verified' || document?.deleted === '1'
  const typeText = LABELS[document?.document_type] || '-'

  return (
    <CollapsibleContainer
      title={typeText}
      smallBorder
      showToggle={false}
      defaultOpen
      textStyle="small"
      isLocked={isLocked}
    >
      <LabeledValue
        key="Status"
        label={<LabelText>{t('common.status', 'Status')}</LabelText>}
        value={
          <DocumentStatusComponent
            status={documentStatus}
            document={document}
            isLocked={isLocked}
          />
        }
        showBorder
        isLoading={isLoading}
      />
      <LabeledValue
        key="Source"
        label={<LabelText>{t('common.source', 'Source')}</LabelText>}
        value={
          <DocumentView
            onClick={document?.onClick}
            isDisabled={disabled}
            size="small"
            isLocked={isLocked}
            documentStatus={standalone ? 'standalone' : documentStatus}
          />
        }
        showBorder
        isLoading={isLoading}
      />
    </CollapsibleContainer>
  )
}

export default Mobile
